import { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import DespachoClientInboxPanel from "@/components/despacho/DespachoClientInboxPanel";
import WhatsAppWebAnchoredPanel from "@/components/despacho/WhatsAppWebAnchoredPanel";
import { DespachoInfoCallout } from "@/components/despacho/DespachoUi";
import { Button } from "@/components/ui/button";
import { SuggestedClientMessagesPanel } from "@/pages/despacho/FiscalRemindersPanels";
import {
  CLIENTES_VIEW_LEGACY_MOCK,
  CLIENTES_VIEW_WHATSAPP_EMBED,
  isWhatsAppEmbedViewMode,
  readClientesAtencionViewMode,
  writeClientesAtencionViewMode,
} from "@/modules/despacho/clientesAtencionViewMode";

/**
 * Atención a clientes — WhatsApp Web anclado (predeterminado) o bandeja demo anterior (reversible).
 * @param {{ embedded?: boolean, viewerRole?: string, viewerStaffId?: string, despachoModuleActive?: boolean }} props
 */
export default function ClientesAtencionPanel({
  embedded = false,
  viewerRole = "owner",
  viewerStaffId = "",
  despachoModuleActive = true,
}) {
  const [viewMode, setViewMode] = useState(() => readClientesAtencionViewMode());

  const switchToLegacy = useCallback(() => {
    writeClientesAtencionViewMode(CLIENTES_VIEW_LEGACY_MOCK);
    setViewMode(CLIENTES_VIEW_LEGACY_MOCK);
  }, []);

  const switchToWhatsApp = useCallback(() => {
    writeClientesAtencionViewMode(CLIENTES_VIEW_WHATSAPP_EMBED);
    setViewMode(CLIENTES_VIEW_WHATSAPP_EMBED);
  }, []);

  if (!despachoModuleActive) {
    return (
      <DespachoClientInboxPanel
        embedded={embedded}
        viewerRole={viewerRole}
        viewerStaffId={viewerStaffId}
        despachoModuleActive={false}
      />
    );
  }

  const viewToggle = (
    <div className="flex flex-wrap items-center gap-2 text-[10px]">
      {isWhatsAppEmbedViewMode(viewMode) ? (
        <Button
          type="button"
          variant="link"
          className="h-auto p-0 text-[10px] text-slate-500 underline"
          onClick={switchToLegacy}
          data-testid="clientes-atencion-use-legacy"
        >
          Usar bandeja demo anterior
        </Button>
      ) : (
        <Button
          type="button"
          variant="link"
          className="h-auto p-0 text-[10px] text-[#0F2D5C] underline"
          onClick={switchToWhatsApp}
          data-testid="clientes-atencion-use-whatsapp"
        >
          Usar WhatsApp Web anclado
        </Button>
      )}
      {!embedded ? (
        <span className="text-slate-400">·</span>
      ) : null}
      {!embedded ? (
        <Link to="/despacho/mensajes?tab=clientes" className="text-[#0F2D5C] underline">
          Pantalla completa
        </Link>
      ) : null}
    </div>
  );

  if (!isWhatsAppEmbedViewMode(viewMode)) {
    return (
      <div className="space-y-4" data-testid="clientes-atencion-legacy">
        <DespachoInfoCallout>
          Vista anterior (bandeja demo). Para WhatsApp real use{" "}
          <button type="button" className="underline font-medium" onClick={switchToWhatsApp}>
            WhatsApp Web anclado
          </button>
          .
        </DespachoInfoCallout>
        {viewToggle}
        <SuggestedClientMessagesPanel />
        <DespachoClientInboxPanel
          embedded={embedded}
          viewerRole={viewerRole}
          viewerStaffId={viewerStaffId}
          despachoModuleActive
        />
      </div>
    );
  }

  return (
    <div className="space-y-3" data-testid="clientes-atencion-whatsapp">
      <DespachoInfoCallout>
        <strong>WhatsApp Web oficial</strong> en ventana anclada al recuadro (no iframe). Use los borradores a la
        izquierda y envíe desde WhatsApp Business. Reversible:{" "}
        <button type="button" className="underline font-medium" onClick={switchToLegacy}>
          bandeja demo anterior
        </button>
        .
      </DespachoInfoCallout>
      {viewToggle}
      <div
        className={
          embedded
            ? "flex flex-col gap-3"
            : "grid grid-cols-1 xl:grid-cols-[minmax(280px,360px)_1fr] gap-4 items-start"
        }
      >
        <div className="space-y-3 min-w-0">
          <SuggestedClientMessagesPanel />
        </div>
        <WhatsAppWebAnchoredPanel compact={embedded} />
      </div>
    </div>
  );
}
